import {
    createMountsBottomFrameSortConfig,
    createMountsGlazingGasketConfig,
    createMountsSideFrameSortConfig,
    createMountsStripesConfig,
    createMountsTopFrameSortConfig,
} from "../../base";
import { IComponentConfig } from "@/app/@types/base-component";
import { Partition } from "@/app/domain/entities/partition";
import { MountsService } from "@/app/services/mounts.service";

const createSwingDoorMountsTopFrameSortConfig = (
    partition: Partition,
): IComponentConfig => {
    const widthWithoutDoor = MountsService.getTopFrameWidth(partition);
    const totalWidth = MountsService.getTotalWidth(partition);

    const hasTransom = MountsService.hasOverdoorTransom(partition);
    const qty = hasTransom ? totalWidth : widthWithoutDoor

    return createMountsTopFrameSortConfig().qty(0).area(qty).build();
};

const createSwingDoorMountsSideFrameSortConfig = (
    partition: Partition,
): IComponentConfig => {
    const totalHeight = MountsService.getTotalHeight(partition);
    const sides = 2;

    const qty = Math.round(totalHeight * sides) || 0;

    return createMountsSideFrameSortConfig().qty(0).area(qty).build();
};

const createSwingDoorMountsBottomFrameSortConfig = (
    partition: Partition,
): IComponentConfig => {
    const sides = 1;
    const qty = MountsService.getBottomFrameWidth(partition) * sides;

    return createMountsBottomFrameSortConfig().qty(0).area(qty).build();
};

const createSwingDoorMountsGlazingGasketConfig = (
    partition: Partition,
): IComponentConfig => {
    const totalWidth = MountsService.getTotalWidth(partition);
    const totalHeight = MountsService.getTotalHeight(partition);
    const doorWidth = MountsService.getDoorTotalWidth(partition);
    const hasTransom = MountsService.hasOverdoorTransom(partition);

    const sides = 2;
    const transomMultiplier = hasTransom ? 1 : sides;

    const totalDoorWidth = doorWidth * transomMultiplier;//top and bottom sides
    const horizontalGaskets = totalWidth * sides - totalDoorWidth;//top and bottom sides
    const verticalGaskets = totalHeight * sides;//left and right sides

    const qty = Math.round((horizontalGaskets + verticalGaskets) * sides) || 0; //inner and outer sides

    return createMountsGlazingGasketConfig().qty(0).area(qty).build();
};

const createSwingDoorMountsStripesConfig = (
    partition: Partition,
): IComponentConfig => {
    const totalWidth = MountsService.getTotalWidth(partition);
    const lines = MountsService.getStipJointsQty(partition);
    // const length = lines * totalWidth; // changes due to task 869aha16k

    return createMountsStripesConfig()
        .qty(lines)
        .area(lines)
        .width(totalWidth)
        .build();
};

export const CGS200SwingDoorsConfigs = (partition: Partition) => [
    createSwingDoorMountsTopFrameSortConfig(partition),
    createSwingDoorMountsSideFrameSortConfig(partition),
    createSwingDoorMountsBottomFrameSortConfig(partition),
    createSwingDoorMountsGlazingGasketConfig(partition),
    createSwingDoorMountsStripesConfig(partition),
];
